'use client';
import styles from '@/components/soopi/styles.module.css';
import Embed from '@/components/soopi/Embed';
import useSoopiEmbedStore from '@/stores/main/soopiEmbed';
import {sendLegacyInflowPathLog} from '@/utils/main/my/log';

const Preview = (props) => {
  const {$streamerName, broadType, broadUrl, handleClose, data} = props;
  const {player} = useSoopiEmbedStore();
  const handleClick = () => {
    const {
      broad_no = '',
      streamer_id = '',
      inflow_path = '',
      contents_type = '',
      contents_value = '',
      recommend_type = '',
    } = data || {};

    player.pause();
    window.open(broadUrl);
    sendLegacyInflowPathLog({
      broadcastId: broad_no,
      streamerId: streamer_id,
      type: contents_type,
      isLogSendData: {
        path1: inflow_path,
        path2: 'full',
        contents_type,
        contents_value,
        is_autoplay: false,
        recommend_type,
      },
    });
  };

  return (
    <div className={styles['soopi-dialog-wrapper']}>
      <div className={styles['soopi-dialog-header']}>
        <span className={styles['soopi-dialog-title']}>
          {$streamerName}의 추천 {broadType}
        </span>
        <button
          type='button'
          onClick={handleClose}
          className={styles['btn_close']}>
          <svg
            width='32'
            height='32'
            viewBox='0 0 32 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <g id='&#235;&#178;&#132;&#237;&#138;&#188;_&#236;&#149;&#132;&#236;&#157;&#180;&#236;&#189;&#152;&#237;&#152;&#149;/32x32/bt_icon_32'>
              <g id='etc/icon_close'>
                <g id='x-01'>
                  <path
                    id='Icon'
                    d='M24 8L8 24M24 24L8 8'
                    stroke='#FCFCFD'
                    strokeWidth='1.4'
                    strokeLinecap='round'
                  />
                </g>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <Embed broadType={broadType} broadUrl={broadUrl} />
      <button className={styles['btn_player']} onClick={handleClick}>
        플레이어로 이동
      </button>
    </div>
  );
};

export default Preview;
